"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const TickerLabel = styled_components_1.default.div `
  padding: 4px;
  background: #e9ebef;
  border-radius: 6px;
  text-align: center;
  min-width: 35px;
  font-weight: 600;
  font-size: 14px;
  line-height: 16.71px;
`;
exports.default = TickerLabel;
//# sourceMappingURL=TickerLabel.js.map